import type { PortalItemDto, SignaturePath } from "../api/types";

// Review loop (D6a / Q7) — the ONE place the portal decides which signing
// route an item takes. The server now sends `resolvedSignaturePath`, the path
// it actually enforces (null = no signature), and every surface and the step
// indicator must follow it rather than reading `signaturePath`: the two
// disagree when a signature is required but the template names no path (the
// server resolves that to InHouse).
//
// Older payloads (fixtures, a backend without the field) omit it; only then do
// we fall back to the rules the portal used before, per kind, so a missing
// field reproduces the previous behaviour exactly instead of inventing a route.

export type SigningRouteInput = Pick<
  PortalItemDto,
  "kind" | "requiresSignature" | "signaturePath" | "resolvedSignaturePath"
>;

export function signingRouteFor(item: SigningRouteInput): SignaturePath | null {
  if (item.resolvedSignaturePath !== undefined) return item.resolvedSignaturePath;
  if (item.kind === "ESign") {
    // ESign items went to DocuSign unless the template opted into in-house.
    return item.signaturePath === "InHouse" ? "InHouse" : "DocuSign";
  }
  return item.requiresSignature && item.signaturePath === "InHouse" ? "InHouse" : null;
}

/** Recipient-facing copy for a Form/Education item whose server-enforced
 *  signing route is DocuSign — a combination the portal cannot fulfil. The
 *  server refuses the submit with the same sentence. */
export const SIGNATURE_STEP_NOT_SET_UP =
  "This item needs a signature step that isn't set up — please contact your Phoenix contact.";
